import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const MetaPixelTracker = () => {
  const location = useLocation();

  useEffect(() => {
    if (window.fbq) {
      window.fbq('track', 'PageView'); // Track every route change
    }
  }, [location.pathname]);

  return null;
};

export default MetaPixelTracker;
